var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.preloadingDone)?[_c('asideMenu'),_c('routerViewBox'),_c('v-navbar')]:[_c('loading')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }